import axios from 'axios'
import API from '@/API.js'

const apiClient = axios.create({
  baseURL: `${API}/bancos`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: localStorage.getItem('argusblack.token')
  }
})

// Actualización del token de autorización
document.addEventListener('actualizar:token', function(e) {
  apiClient.defaults.headers['Authorization'] = e.detail
})

// Eliminación del token de autorización
document.addEventListener('eliminar:token', function() {
  apiClient.defaults.headers['Authorization'] = null
})

export default {
  actualizar(banco) {
    return apiClient.post(`${banco.id}`, banco)
  },

  eliminar(idBanco) {
    return apiClient.delete(`${idBanco}`)
  },

  guardar(banco) {
    return apiClient.post('', banco)
  },

  bancoJSON(idBanco) {
    return apiClient.get(`${idBanco}.json`)
  },

  bancosJSON() {
    return apiClient.get(`${API}/bancos.json`)
  }
}